/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * fleetster
 * OpenAPI spec version: 1.0.0
 */

export type AvailableTenantDtoAccess = typeof AvailableTenantDtoAccess[keyof typeof AvailableTenantDtoAccess];


export const AvailableTenantDtoAccess = {
  member: 'member',
  'data-sharing': 'data-sharing',
} as const;
